import React from 'react';
import './what-is-it.css';
import SideImage from '../side-image/SideImage';
import whatIsImage from '../../../assets/what-is-it-side-img-661x617.jpg';
import TechLines1 from '../elements-svg/TechLines1';
import CTAButton from '../cta-button/CTAButton';
import RightArrowCircular from '../elements-icons/RightArrowCircular';

const WhatIsIt = () => {
  return (
    <section className='section-what-is'>
      <div className='section-what-is-svg'>
        <TechLines1 width='400px' />
      </div>
      <div
        className='wrapper-what-is-top'
        id='what-is-it'>
        <h2 className='title-sub-1'>
          So, What is a Prompt?
        </h2>
        <p className='paragraph-dk'>
          It's simple, a prompt is like your question to an AI. For chatbots like ChatGPT, Bard, Claude, and others, it's the phrase you type in. Think of it as giving direction, and in return, the AI offers its insight.
        </p>
      </div>
      <div className='wrapper-what-is-bottom'>
        <div className='content-what-is'>
          <h3 className='title-sub-2'>
            The Prompt
          </h3>
          <p className='paragraph-dk'>
            In less than 200 words describe a sunset to someone who's never seen one, formatted as two paragraphs.
          </p>
          <h3 className='title-sub-2'>
            The Response
          </h3>
          <p className='paragraph-dk'>
            A sunset is a daily masterpiece that paints the sky, signaling the transition between day and night. As the sun descends towards the horizon, the sky morphs into a canvas of rich and vibrant hues, ranging from deep oranges and fiery reds to soft pinks and purples. These colors blend seamlessly, creating a gradient of warmth that stands in stark contrast to the usual blue of the daytime sky.<br/><br/>Witnessing a sunset is not just a visual experience; it evokes a myriad of emotions. The world seems to slow down, allowing one to reflect and find tranquility in the fleeting moment. The merging colors often serve as a reminder of nature's grandeur, with the diminishing light symbolizing the impermanence of time. Every sunset, though consistent in its occurrence, offers a unique display of beauty that captivates and leaves an indelible mark on the soul.
          </p>
          <div className='wrapper-cta-center-mobile'>
            <CTAButton url='/prompt-library' className='btn-cta-sub bg-straight-gradient-purple text-lt' content='Go To Prompt Library' icon={<RightArrowCircular svgClass='icon-sm' pathClass='icon-wht' />} />
          </div>
        </div>
        <SideImage imgClass='bg-lt-pink' imgSrc={whatIsImage} altText='What is it?' />
      </div>
    </section>
  );
}

export default WhatIsIt;
